import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import roleAccessManager from '@/utils/role-access-manager'

/**
 * Current active route path dan action type untuk dikirim ke backend
 */
let currentRoutePath = localStorage.getItem('default_dashboard_path') || '/'
let currentActionType = 'read' as 'read' | 'create' | 'update' | 'delete'

/**
 * Set current route path dan action type
 */
export function setCurrentRouteContext(path: string, action: 'read' | 'create' | 'update' | 'delete' = 'read') {
  currentRoutePath = path
  currentActionType = action
}

/**
 * Get current route context
 */
export function getCurrentRouteContext() {
  return {
    path: currentRoutePath,
    action: currentActionType
  }
}

/**
 * Axios interceptor untuk menambahkan route context ke header
 */
export function setupAxiosInterceptor(instance: AxiosInstance) {
  instance.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      // Gabungkan path dan action menjadi 1 header dengan format base64
      if (config.headers) {
        const contextString = `${currentActionType}:${currentRoutePath}`
        const encodedContext = btoa(contextString)
        config.headers['X-Context'] = encodedContext
      }
      
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  // Response interceptor untuk logging
  instance.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      console.error('[API Error]', error.config?.url, error.response?.status, error.message)
      return Promise.reject(error)
    }
  )
}

export default {
  setCurrentRouteContext,
  getCurrentRouteContext,
  setupAxiosInterceptor
}
